/**
 * Site navigation – used by Header for tabs and dropdowns.
 */

export const headerNav = [
  { label: 'About', path: '/about' },
  {
    label: 'Tracks',
    dropdown: [
      { label: 'For Corporates', path: '/tracks/corporates' },
      { label: 'For Individuals', path: '/tracks/individuals' },
      { label: 'For Colleges', path: '/tracks/colleges' },
    ],
  },
  // {
  //   label: 'Courses',
  //   dropdown: [
  //     { label: 'Salesforce', path: '/offerings/salesforce' },
  //     { label: 'Web Development', path: '/course/web-development' },
  //     { label: 'Full Stack Development', path: '/course/full-stack-web-development' },
  //   ],
  // },
  // { label: 'Resources', path: '/resources' },
  { label: 'Blog', path: '/blog' },
  // { label: 'Campaigns', path: '/campaigns' },
  { label: 'Contact Us', path: '/contact' },
];
